import { AbgSxProps, Brand } from '@abg/typings';

import { FIELD_STYLES } from '../../organisms/BookingWidget/booking-widget.styles';

export const dateTimePopperStyles: AbgSxProps = {
  zIndex: 5,
  maxWidth: '100%',
  overflow: {
    xs: 'auto',
    md: 'unset',
  },
  bottom: {
    xs: '0',
    md: 'unset',
  },
  width: {
    xs: '100%',
    md: 'auto',
  },
  paddingTop: {
    xs: '64px', // 64 is header height
    md: 'unset',
  },
};

export const bookingWidgetDateTimePopperStyles: AbgSxProps = {
  ...dateTimePopperStyles,
  maxWidth: {
    xs: '100%',
    md: 'unset',
  },
};

export const bookingWidgetFullScreenDrawerStyles: AbgSxProps = {
  // Above MUI's default tooltip z-index (1500) so the full-screen calendar
  // covers page-level tooltips (e.g. the header's "Sign in" prompt).
  zIndex: 1501,
};

export const bookingWidgetFullScreenPaperStyles: AbgSxProps = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
  overflow: 'hidden',
};

export const bookingWidgetFullScreenRootStyles: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
};

export const bookingWidgetFullScreenCalendarStyles: AbgSxProps = {
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  WebkitOverflowScrolling: 'touch',
  width: '100%',
  padding: '0 24px 16px',
  '& [data-testid="dateRangePicker"]': {
    width: '100%',
    maxWidth: '100%',
  },
  '& .rdp-root': {
    width: '100%',
  },
  '& .rdp-root .rdp-months': {
    flexWrap: 'wrap',
    justifyContent: 'center',
    width: '100%',
  },
};

export const bookingWidgetFullScreenFooterStyles: AbgSxProps = {
  flexShrink: 0,
  backgroundColor: '#fff',
  boxShadow: '0px -2px 10px 0px rgba(0, 0, 0, 0.06)',
  zIndex: 1,
};

export const dateTimePopperContainerStyles = (brand: Brand) => ({
  backgroundColor: '#fff',
  // backgroundColor: 'transparent',
  maxWidth: '100%',
  boxShadow: 3,
  display: {
    xs: 'flex',
    md: 'block',
  },
  flexFlow: 'column',
  minHeight: {
    xs: '100%',
    md: 'auto',
  },
  borderRadius: FIELD_STYLES[brand].borderRadius,
  paddingBottom: {
    xs: '76px', // height of the bottom bar
    md: 0,
  },
  paddingTop: '16px',
});

export const timePickerContainerStyles: AbgSxProps = {
  display: 'flex',
  borderBottom: '1px solid #D9D9D9',
  borderTop: '1px solid #D9D9D9',
  '& .MuiOutlinedInput-root:has(.MuiSelect-outlined)': {
    height: 'unset !important',
  },
  flexWrap: 'wrap',
  margin: '0 auto',
  width: {
    xs: '100%',
    md: 'unset',
  },
};

export const timePickerWrapperStyles: AbgSxProps = {
  borderRight: { xs: 'none', md: '1px solid #D9D9D9' },
  width: { xs: '100%', md: 'unset' },
};
